export default {
  "club_currency_not_configured": "Monnaie du club non configurée",
  "please_configure_a_currency_in_control_to_view_cost_comparisons": "Veuillez configurer une devise dans Contrôle pour voir les comparaisons de coûts.",
  "currency_lookup_failed": "Contrôle de la monnaie échouée",
  "defaulted_to_gbp_until_the_currency_service_is_available": "Défaut à GBP jusqu'à ce que le service de change soit disponible.",
  "failed_to_load_budgets": "N ' a pas été chargé des budgets",
  "failed_to_load_budget_references": "Failed to load budget reference",
  "sent_to_budget": "Envoyé au budget",
  "budget_line_created_for_board_approval": "Ligne budgétaire créée pour l'approbation du conseil.",
  "failed_to_send_to_budget": "N ' a pas été envoyé au budget",
  "failed_to_award_rfq": "N'a pas obtenu de rfq",
  "cost_advantage": "Prime de coût",
  "quality_advantage": "Davantage qualité",
  "service_advantage": "Avantages du service",
  "head_to_head_bidder_battle": "Bataille de l'échelle de tête-à-tête",
  "select_rfq_to_compare": "Sélectionnez RFQ pour comparer",
  "cost_weight": "Coût Poids",
  "quality_weight": "Poids de qualité",
  "service_weight": "Poids du service",
  "total_weight": "Poids total:",
  "total_weight_must_be_100_currently": "Le poids total doit être ≤ 100%. Actuellement",
  "reduce_by": "% (réduire par",
  "reset_to_template": "Réinitialiser le modèle",
  "set_at_least_one_weight_above_0_to_run_the_comparison": "Définissez au moins un poids supérieur à 0% pour exécuter la comparaison.",
  "calculating": "Calculer...",
  "run_battle_analysis": "Exécutez l'analyse de bataille",
  "calculating_battle_outcome": "Calculer le résultat de la bataille...",
  "winner": "Gagnant",
  "tie": "Cravate",
  "lead_margin": "Marge de prospect",
  "biggest_differentiator": "Le plus grand différentiateur",
  "challenger_a": "Adversaire A",
  "winner_32": "GAGNANT",
  "tie_33": "TIE",
  "total_cost": "Total",
  "final_score_10": "Note finale (/10)",
  "evaluate": "Évaluer",
  "cost_score": "Cote des coûts :",
  "quality_score": "Score de qualité:",
  "service_score": "Points de service :",
  "unknown": "Inconnu",
  "send_to_budget": "Envoyer au budget",
  "awarding": "Attribuer...",
  "award": "Prix",
  "this_rfq_was_sent_to_budget_with_a_different_bid": "Ce RFQ a été envoyé au budget avec une offre différente.",
  "challenger_b": "Adversaire B",
  "awaiting_submissions": "Attending Submissions",
  "awaiting_more_bidder_submissions_for_this_rfq": "Attendre d'autres soumissionnaires pour ce RFQ.",
  "category_breakdown": "Répartition par catégorie",
  "quality_score_49": "Score de qualité",
  "service_score_50": "Score du service",
  "ready_for_battle": "Prêt pour la bataille !",
  "no_submissions_available_yet_for_the_selected_rfq": "Aucune soumission n'est encore disponible pour le RFQ sélectionné.",
  "select_an_rfq_with_multiple_submissions_to_start_the_head_to_head": "Sélectionnez un RFQ avec plusieurs soumissions pour commencer la comparaison tête-à-tête",
  "no_rfqs_available": "Aucun RFQ disponible",
  "there_are_no_rfqs_to_compare_please_create_or_import_rfqs_to_use_": "Il n'y a pas de QR à comparer. S'il vous plaît créer ou importer des QR pour utiliser cette fonctionnalité.",
  "award_without_board_approval": "Prix sans approbation par le conseil ?",
  "are_you_sure_board_approval_is_not_required_for_awarding_this_bid": "Êtes-vous sûr que l'approbation du conseil n'est pas nécessaire pour attribuer cette offre? Cette action sera enregistrée.",
  "cancel": "Annuler",
  "yes_award_anyway": "Oui, le prix de toute façon",
  "select_an_existing_budget_to_create_a_board_approved_earmark": "Sélectionnez un budget existant pour créer une marque d'écoute approuvée par le conseil d'administration.",
  "budget": "Budget",
  "no_budgets_available": "Aucun budget disponible",
  "gl_account": "Compte du grand livre",
  "department": "Département",
  "owner_optional": "Propriétaire (facultatif)",
  "search_staff_by_name_or_email": "Rechercher le personnel par nom ou email",
  "unassigned": "Non attribué",
  "searching": "Recherche…",
  "no_matches": "Pas de correspondance",
  "type_at_least_2_characters_to_search": "Saisissez au moins 2 caractères pour rechercher.",
  "searching_staff": "Le personnel de recherche...",
  "select_a_staff_member_to_assign_ownership": "Sélectionnez un fonctionnaire pour attribuer la propriété.",
  "category": "Catégorie",
  "total_amount": "Montant total",
  "currency": "Monnaie :",
  "month_allocation": "Affectation du mois",
  "single_month_charge": "Frais mensuels",
  "split_across_months": "Séparer pendant des mois",
  "month": "Mois",
  "amount": "Montant",
  "remove": "Retirer",
  "add_month": "Ajouter le mois",
  "allocated_total": "Total réparti :",
  "allocation_total_must_match_the_total_amount": "Le total de l'allocation doit correspondre au montant total.",
  "sending": "Envoi…",
  "contract_renewal_alerts": "Alertes de renouvellement du contrat",
  "ai_powered_contract_renewal_predictions_and_recommendations": "Prédictions et recommandations de renouvellement des contrats alimentés par l'IA",
  "critical": "Critique",
  "refresh": "Actualiser",
  "upcoming_renewals": "Renouvellements à venir",
  "next_30_days": "30 prochains jours",
  "critical_risk": "Risque critique",
  "require_attention": "Require l ' attention",
  "total_value": "Valeur totale",
  "annual_contracts": "Contrats annuels",
  "avg_performance": "Performance avg",
  "out_of_100": "sur 100",
  "all_contracts": "Tous les contrats",
  "risk": "Risques",
  "contract": "Contrat",
  "contract_ends": "Fin du contrat",
  "days_to_decide": "jours pour décider",
  "current_value": "Valeur actuelle",
  "predicted_increase": "% de l ' augmentation prévue",
  "performance_score": "Rendement des résultats",
  "alternatives": "Alternatives",
  "bidders": "soumissionnaires",
  "ai_recommendation": "Recommandation d ' AI :",
  "risk_factors": "Facteurs de risque:",
  "last_review": "Dernier examen :",
  "start_negotiation": "Commencer la négociation",
  "schedule_review": "Annexe Examen",
  "no_contract_renewals": "Aucun renouvellement du contrat",
  "no_contracts_match_the_selected_risk_level": "Aucun contrat ne correspond au niveau de risque choisi.",
  "usda_market_news": "Actualités du marché",
  "food_agricultural_commodities": "Produits alimentaires et agricoles",
  "eia_energy_data": "EIA Energy Data",
  "fuel_prices_and_energy_costs": "Prix du carburant et coûts énergétiques",
  "bureau_of_labor_statistics": "Bureau des statistiques du travail",
  "cpi_ppi_indices_for_service_categories": "Indices de l ' IPC/IPP pour les catégories de services",
  "wine_searcher": "Vin-chercheur",
  "global_wine_pricing_database": "Base mondiale de données sur les prix du vin",
  "liv_ex": "Liv-ex",
  "fine_wine_trading_platform": "Plateforme d'échange de vin",
  "mintec": "Mintec",
  "food_ingredient_pricing": "Prix des ingrédients alimentaires",
  "opis": "OPIS",
  "intraday_fuel_pricing": "Prix du carburant intérieur",
  "price_index_data_sources": "Indice de prix Sources de données",
  "core_data_sources": "Sources de données de base",
  "included": "Inclus",
  "updates": "Mises à jour :",
  "enhanced_data_sources": "Sources de données améliorées",
  "available": "Disponible",
  "premium_feature": "Fonctionnalité premium",
  "enhanced_data_sources_provide_deeper_market_intelligence_with_rea": "Les sources de données améliorées fournissent une intelligence de marché plus profonde avec les prix en temps réel, les catégories de spécialité et l'analyse avancée. Contactez votre représentant Privana pour activer ces aliments premium.",
  "data_sources_update_automatically_changes_take_effect_within_1_ho": "Les sources de données se mettent à jour automatiquement. Les changements entrent en vigueur dans une heure.",
  "save_settings": "Sauvegarder les paramètres",
  "failed_to_load_bidders": "N'a pas chargé les soumissionnaires",
  "all_bidders": "Toutes les échelles",
  "master_directory_of_vendors_across_all_rfqs": "Master répertoire des fournisseurs dans tous les RFQ",
  "search_by_name_or_email": "Recherche par nom ou email",
  "status": "Statut",
  "all": "Tous",
  "active": "Actif",
  "inactive": "Inactif",
  "name": "Nom",
  "contact": "Contact",
  "email": "E-mail",
  "website": "Site Web",
  "phone": "Téléphone",
  "last_updated": "Dernière mise à jour",
  "loading_bidders": "Charger les soumissionnaires...",
  "no_bidders_found": "Aucun soumissionnaire n'a trouvé.",
  "showing_0_bidders": "Affichage de 0 soumissionnaires",
  "previous": "Précédent",
  "next": "Suivant",
  "active_rfqs": "RFQ actifs",
  "data_unavailable": "Données non disponibles",
  "total_submissions": "Total des soumissions",
  "submitted_bids": "soumissions soumises",
  "club_currency": "devise du club",
  "avg_response_time": "Temps de réponse Avg",
  "to_submission": "à soumettre",
  "cost_savings_vs_budget": "Économies de coûts par rapport au budget",
  "weighted_across_rfqs": "pondéré sur les demandes de devis",
  "urgent_rfqs": "QR d ' urgence",
  "no_urgent_rfqs": "Aucun RFQ urgent",
  "no_deadline": "Pas de délai",
  "recent_activity": "Activité récente",
  "no_recent_activity": "Aucune activité récente",
  "rfq_processing_time": "Temps de traitement du RFQ",
  "average_response_time": "temps de réponse moyen",
  "bidder_participation": "Participation des soumissionnaires",
  "avg_submissions_per_rfq": "présentations avg par RFQ",
  "cost_savings": "Économies",
  "vs_budgeted_amounts": "c) Montants budgétisés",
  "bidder_performance_heatmap": "Soumissionnaire Performance Heatmap",
  "high_risk_only": "Risque élevé seulement",
  "medium_risk_only": "Risque moyen seulement",
  "low_risk_only": "Risque faible seulement",
  "avg_lead_time": "Délai moyen",
  "days": "jours",
  "avg_price_variance": "Variance de prix Avg",
  "avg_reliability": "Fiabilité d ' Avg",
  "high_risk": "Risque élevé",
  "risk_188": "risque",
  "lead_time": "Temps mort:",
  "price_variance": "Écart de prix:",
  "reliability": "Fiabilité :",
  "sla_breaches": "Les atteintes à la sla:",
  "risk_193": "Risque :",
  "heat_score": "Score de chaleur:",
  "no_bidder_data": "Aucune donnée relative à l ' échelle",
  "click_generate_demo_data_to_see_bidder_locations_and_performance_": "Cliquez sur \"Generate Demo Data\" pour voir les emplacements des soumissionnaires et les paramètres de performance",
  "legend": "Légende",
  "low_risk_bidders": "Bidders à faible risque",
  "medium_risk_bidders": "Bidders à risque moyen",
  "high_risk_bidders": "Échelles à risque élevé",
  "circle_size_indicates_heat_score_larger_higher_risk_variance": "La taille du cercle indique le score de la chaleur (larger = risque/variance plus élevé)",
  "new_procurement_request": "Demande d ' achat",
  "request_title": "Titre de la demande *",
  "brief_description_of_what_you_need": "Brève description de ce dont vous avez besoin",
  "detailed_description": "Description détaillée *",
  "provide_detailed_requirements_specifications_quantities_etc": "Fournir des exigences détaillées, spécifications, quantités, etc.",
  "your_department": "Votre département",
  "select_category": "Sélectionnez la catégorie",
  "products": "Produits",
  "services": "Services",
  "maintenance": "Maintenance",
  "technology": "Technologie",
  "food_beverage": "Aliments et boissons",
  "other": "Autre",
  "estimated_budget": "Budget estimatif",
  "required_by_date": "Obligatoire par date",
  "urgency": "Urgence",
  "low": "Faible",
  "medium": "Moyen",
  "high": "Élevé",
  "urgent": "Urgence",
  "submit_request": "Demande de soumission",
  "unable_to_generate_rfq": "Impossible de générer du RFQ",
  "ai_powered_rfq_builder": "Aï-powered rfq builder",
  "describe_your_procurement_need": "Décrivez votre besoin d'approvisionnement",
  "what_do_you_need_be_as_specific_as_possible": "Qu'est-ce que vous avez besoin? (Soyez aussi précis que possible)",
  "e_g_we_need_a_weekly_linen_service_for_our_dining_room_including_": "Nous avons besoin d'un service de linge hebdomadaire pour notre salle à manger, y compris des nappes, serviettes et serviettes de cuisine. Nous servons environ 300 couverts par semaine et avons besoin d'une qualité supérieure avec garantie d'enlèvement de taches...",
  "ai_will_help_you_with": "AI vous aidera avec:",
  "professional_rfq_structure_and_language": "• Structure professionnelle du RFQ et langue",
  "industry_specific_requirements_and_compliance": "• Exigences propres à l’industrie et conformité",
  "evaluation_criteria_recommendations": "• Recommandations sur les critères d’évaluation",
  "contract_terms_suggestions": "• Propositions de termes de contrat",
  "line_item_specifications": "• Spécifications de l'article de ligne",
  "ai_generated_rfq_review_edit": "Demande de devis générée par IA – Vérifier et modifier",
  "title": "Titre",
  "description": "Description",
  "urgent_rfq": "RFQ urgent",
  "flag_for_expedited_procurement_review": "Drapeau pour l'examen accéléré des achats.",
  "link_budget_line_staff_only": "Lien budgétaire (personnel seulement)",
  "clear_selection": "Sélection claire",
  "budget_amounts_remain_hidden_from_bidders": "Les montants budgétaires restent cachés des soumissionnaires.",
  "line_items": "Éléments de ligne",
  "add_item": "Addition",
  "item_name": "Nom de l ' article",
  "unit_of_measure": "Unité de mesure",
  "e_g_each_kg_hours": "par exemple, chaque kg, heures",
  "quantity": "Quantité",
  "est_unit_cost": "Coût unitaire ($)",
  "specifications": "Caractéristiques",
  "detailed_specifications_quality_requirements_etc": "Spécifications détaillées, exigences de qualité, etc.",
  "rfq_summary": "RFQ Résumé",
  "urgent_252": "Urgent :",
  "yes": "Oui",
  "budget_line": "Ligne budgétaire :",
  "line_items_255": "Éléments de ligne (",
  "generating": "Générer...",
  "generate_rfq": "Générer RFQ",
  "review_publish": "Vérifier et publier",
  "create_rfq": "Créer RFQ",
  "cost": "Coût",
  "quality": "Qualité",
  "service": "Service",
  "failed_to_load_rfq": "Ne pas charger rfq",
  "please_configure_a_currency_in_control_before_creating_submission": "Veuillez configurer une devise dans Contrôle avant de créer des soumissions.",
  "bidder_invited_no_email_sent": "Bidder invité (pas d'e-mail envoyé)",
  "invite_created_email_failed": "Invite créée (email failed)",
  "failed_to_invite_bidder": "N ' a pas invité le soumissionnaire",
  "bidder_name_is_required": "Le nom du soumissionnaire est requis",
  "failed_to_create_bidder": "N ' a pas réussi à créer un soumissionnaire",
  "status_updated": "État actualisé",
  "failed_to_update_status": "N ' ont pas mis à jour le statut",
  "scoring_template_updated": "Modèle de notation mis à jour",
  "failed_to_update_scoring_template": "Ne pas mettre à jour le modèle de notation",
  "enter_scores_before_saving": "Entrez les scores avant d'enregistrer",
  "evaluation_saved": "Évaluation sauvegardée",
  "failed_to_save_evaluation": "N'a pas réussi à économiser l'évaluation",
  "select_a_bidder_first": "Sélectionnez un soumissionnaire en premier",
  "please_configure_a_currency_before_creating_submissions": "Veuillez configurer une devise avant de créer des soumissions.",
  "submission_saved": "Soumission enregistrée",
  "failed_to_save_submission": "N ' a pas réussi à enregistrer la soumission",
  "failed_to_promote_supplier": "Le fait de ne pas promouvoir le fournisseur",
  "portal_link_copied": "Lien du portail copié",
  "failed_to_copy_portal_link": "N'a pas copié le lien de portail",
  "portal_link_regenerated": "Lien vers le portail régénéré",
  "failed_to_regenerate_link": "N ' a pas régénéré de lien",
  "failed_to_send_invite_email": "N'a pas envoyé d'e-mail",
  "rfq_detail": "Détail de la demande de devis",
  "back_to_list": "Retour à la liste",
  "loading_rfq_details": "Chargement des détails RFQ...",
  "rfq_not_found": "RFQ non trouvé.",
  "uncategorized": "Non classé",
  "created": "· Créé",
  "invited": "· Invité",
  "submitted": "· Soumis",
  "overview": "Vue d’ensemble",
  "bidders_296": "Soumissionnaires",
  "submissions": "Soumissions",
  "evaluation": "Évaluation",
  "activity": "Activité",
  "deadline": "Date limite :",
  "type": "Type",
  "set_status": "État d ' ensemble",
  "awarded": "Récompensé",
  "awarded_bidder": "Enchère d ' offre",
  "view_supplier": "Fournisseur",
  "promote_to_supplier": "Promouvoir le fournisseur",
  "award_this_rfq_to_promote_the_winning_bidder_into_the_suppliers_m": "Prix ce RFQ pour promouvoir le soumissionnaire gagnant dans le module Fournisseurs.",
  "invited_bidders": "Bidders invités",
  "invited_309": "invités",
  "search_bidders": "Cherchez des soumissionnaires",
  "invite": "L ' invitation",
  "add_a_new_bidder": "Ajouter un nouveau soumissionnaire",
  "bidder_name": "Nom du soumissionnaire",
  "email_optional": "Courriel (facultatif)",
  "create_invite": "Créer \" Invite \"",
  "no_bidders_invited_yet": "Aucun soumissionnaire n'a été invité.",
  "status_317": "État :",
  "submitted_318": "Soumis",
  "more_details": "Plus de détails",
  "last_viewed": "Dernière vue",
  "link_expires": "Le lien expire",
  "revoked": "Ce lien d'invitation a été révoqué. Veuillez demander un nouveau lien du club.",
  "invite_email_sent": "Inviter un courriel envoyé",
  "invite_email_failed": "Inviter e-mail échoué:",
  "submission_confirmation_sent": "Confirmation de soumission envoyée",
  "submission_confirmation_failed": "La confirmation de la soumission a échoué :",
  "copy_link": "Copie du lien",
  "regenerate_link": "Regénérer le lien",
  "send_invite_email": "Envoyer un e-mail",
  "received": "reçues",
  "bidder": "Soumissionnaire",
  "select_invited_bidder": "Sélectionner le soumissionnaire invité",
  "notes": "Notes",
  "currency_334": "Monnaie",
  "club_currency_not_configured_submissions_are_disabled": "Monnaie du club non configurée. Les présentations sont désactivées.",
  "upload_quote_pdf": "Fourchette de téléchargement ( PDF )",
  "saving": "Enregistrement…",
  "save_submission": "Soumission de sauvegarde",
  "no_submissions_yet": "Pas encore de soumissions.",
  "awarded_bid": "Primeed Bid",
  "no_notes": "Pas de notes",
  "view": "Afficher",
  "scoring_template": "Modèle de notation",
  "weight": "Poids (%)",
  "save_template": "Sauvegarder le modèle",
  "weights_must_add_up_to_100": "Les poids doivent s'ajouter à 100%.",
  "no_submissions_available_to_evaluate": "Aucune soumission n'est disponible pour évaluer.",
  "total_score": "Score total :",
  "needs_evaluation": "Évaluation des besoins",
  "cost_rating_0_10": "Cotisation des coûts (0–10)",
  "quality_rating_0_10": "Évaluation de la qualité (0–10)",
  "service_rating_0_10": "Note de service (0–10)",
  "save_evaluation": "Évaluer",
  "requires_board_approved_budget": "Nécessite un budget approuvé par le conseil.",
  "computed_total": "Total calculé :",
  "linked_to_budget": "Lien vers le budget",
  "no_budget_linked_yet_use_evaluation_to_send_a_bid_to_budget": "Aucun budget n'est encore lié. Utiliser l'évaluation pour envoyer une soumission au budget.",
  "no_activity_yet": "Pas encore d'activité.",
  "this_will_create_a_supplier_record_from_the_awarded_bidder_and_li": "Cela créera un dossier fournisseur du soumissionnaire adjugé et le liera à ce QR.",
  "also_create_a_contract_for_renewals": "Également créer un contrat pour les renouvellements",
  "optional_contract_details_will_be_attached_to_the_new_supplier": "Les détails du contrat optionnel seront joints au nouveau fournisseur.",
  "contract_name": "Nom du contrat",
  "start_date": "Date de début",
  "end_date": "Date de fin",
  "renewal_type": "Type de renouvellement",
  "notice_period_days": "Période d ' préavis",
  "value": "Valeur",
  "promoting": "Promouvoir...",
  "confirm": "Confirmer",
  "submission": "Soumission",
  "previous_371": "← Précédent",
  "of": "des",
  "next_373": "Suivant →",
  "pricing_summary": "Résumé des prix",
  "lead_time_375": "Heure d ' avance",
  "validity_date": "Date de validité",
  "no_notes_provided": "Pas de notes fournies.",
  "exclusions": "Exclusions",
  "assumptions": "Hypothèses",
  "attachments": "Attachements",
  "copy_bidder_portal_link": "Copier le lien du portail des soumissionnaires",
  "download": "Télécharger",
  "no_files_attached": "Pas de fichiers joints.",
  "last_updated_384": "Dernière mise à jour",
  "failed_to_load_rfqs": "N ' a pas réussi à charger des rfqs",
  "rfq_status_updated": "Statut de la demande de devis mis à jour",
  "requests_for_quotation_rfqs": "Demandes de citation (QRF)",
  "loading_rfqs": "Chargement RFQs...",
  "invited_389": "Invité:",
  "submitted_390": "Soumis :",
  "created_391": "Création :",
  "invite_more_bidders": "Inviter plus de soumissionnaires",
  "send_to_bidders": "Envoyer aux soumissionnaires",
  "view_details": "Voir les détails",
  "change_status": "État du changement",
  "no_rfqs_found": "Aucun QR n'a été trouvé.",
  "real_time_price_index": "Indice de prix en temps réel",
  "live_usda_food_commodity_pricing_and_bidder_comparisons": "Comparaisons des prix des produits alimentaires et des soumissionnaires en direct USDA",
  "usda_live_data": "Usda données en direct",
  "updating": "Mise à jour...",
  "price_index_enhanced_coming_soon": "Indice de prix Enhanced coming soon",
  "more_categories_with_premium_data_feeds_fuel_linens_wine_technolo": "- Plus de catégories avec des flux de données premium (carburant, linge de maison, vin, technologie).",
  "price_alerts": "alertes tarifaires:",
  "significant_price_movements_detected_in": "Principaux mouvements de prix détectés",
  "5_week_trend_flow": "Débit de tendance de 5 semaines",
  "select_an_item_below_to_view_its_5_week_price_trend": "Sélectionnez un article ci-dessous pour afficher sa tendance de prix de 5 semaines.",
  "all_categories": "Toutes les catégories",
  "no_live_data": "Aucune donnée en direct",
  "vs": "vs $",
  "vs_club_actual": "par rapport au réalisé du club",
  "club_pays": "Le club paie: $",
  "volatility": "Volatilité",
  "awaiting_next_usda_update": "Attendre la prochaine mise à jour de USDA",
  "data_sources_schedule": "Sources de données et calendrier:",
  "usda_market_news_service": "Usda service d'information de marché",
  "last_updated_416": "Dernière mise à jour:",
  "next_update": "Prochaine mise à jour:",
  "updates_automatically_every_monday_at_8_00_am_local_time_or_click": "Mises à jour automatiquement tous les lundis à 8h heure locale, ou cliquez sur Rafraîchissement pour la mise à jour immédiate.",
  "enhanced_available": "Amélioré disponible",
  "contact_support_for_fuel_wine_linens_more": "Contactez l’assistance pour le carburant, le vin, le linge et plus encore",
  "no_usda_price_data_available": "Pas de données de prix usda disponibles",
  "click_refresh_to_load_current_usda_commodity_pricing_data": "Cliquez sur rafraîchir pour charger les données actuelles sur les prix des produits de base USDA.",
  "load_usda_data": "Charge USDA Data",
  "unable_to_prepare_invitation_emails": "Incapable de préparer des courriels d'invitation",
  "review_bidder_emails": "Examen des courriels des soumissionnaires",
  "source": "Source",
  "existing_bidder": "Enchère existant",
  "new_bidder": "Nouveau soumissionnaire",
  "search_all_bidders": "Rechercher tous les soumissionnaires",
  "type_at_least_2_characters": "Type au moins 2 caractères",
  "no_email": "aucun e-mail",
  "company_name": "Nom de la société",
  "contact_first_name": "Prénom de contact",
  "contact_last_name": "Contact nom de famille",
  "existing_bidder_contact_details_are_read_only_here_edit_the_canon": "Les coordonnées actuelles des soumissionnaires sont lues uniquement ici. Éditer le dossier canonique dans All Bidders avant de préparer cette invitation.",
  "this_bidder_or_email_is_already_selected": "Ce soumissionnaire ou email est déjà sélectionné.",
  "add_bidder": "Ajouter le soumissionnaire",
  "your_microsoft_mailbox_is_not_available_connect_or_reconnect_it_i": "Votre boîte aux lettres Microsoft n'est pas disponible. Connectez-le ou reconnectez-le dans Communications avant d'envoyer. Privana ne reviendra pas à l'e-mail du système.",
  "generating_drafts_creates_the_canonical_rfq_bidder_relationship_s": "Générer des ébauches crée la relation canonique RFQ-bidder, de sorte que le nombre sollicité peut augmenter avant que le courriel ne soit envoyé. Ébauche, envoyé et les états de livraison échoués restent suivis séparément.",
  "generate_email_drafts": "Générer des ébauches de courriel",
  "from": "De",
  "to": "To",
  "recipient_is_tied_to_the_selected_canonical_bidder_contact_edit_t": "Le bénéficiaire est lié au contact du soumissionnaire canonique sélectionné. Modifier le soumissionnaire dans tous les soumissionnaires pour le modifier.",
  "subject": "Sujet",
  "body": "Corps",
  "include_online_quote_submission_link": "Inclure un lien de soumission en ligne",
  "adds_a_secure_privana_link_to_this_email_so_the_bidder_can_submit": "Ajoute un lien sécurisé Privana à cet e-mail afin que le soumissionnaire puisse soumettre sa citation directement dans ce RFQ. Éteignez-le si vous voulez que le soumissionnaire réponde ou vous envoie sa citation par e-mail.",
  "retry_this_recipient": "Récupérer ce destinataire",
  "reconciliation_pending": "en attente de réconciliation",
  "recheck_delivery": "Revérifier la livraison",
  "send_this_email": "Envoyer cet email",
  "sent": "Envoyé",
  "close": "Fermer",
  "retry_unsent_recipients": "Récipiendaires irréfutables",
  "send_all_emails": "Envoyez tous les emails",
  "professional": "Administrateurs",
  "formal_and_business_like": "Formal and businesslike",
  "friendly": "Amicalement",
  "warm_and_collaborative": "Warm et collaboration",
  "stern": "Sterne",
  "firm_and_direct": "Cabinet et direct",
  "diplomatic": "Diplomatique",
  "tactful_and_careful": "Tactful et prudent",
  "video_call": "Appel vidéo",
  "phone_call": "Appel téléphonique",
  "in_person_meeting": "Réunion sur le personnel",
  "start_negotiation_469": "Négociation de début -",
  "schedule_review_470": "Examen de l'annexe -",
  "recipients": "Bénéficiaires",
  "bidder_contacts": "Contacts du soumissionnaire",
  "primary": "Primaire",
  "cc_staff_members": "Membres de l’état-major",
  "cc_custom_emails": "Courriels personnalisés CC",
  "enter_email_address": "Entrez l'adresse e-mail",
  "email_content": "Contenu du courriel",
  "tone": "Ton",
  "meeting_type": "Type de réunion",
  "generate_ai_content": "Générer le contenu de l'IA",
  "email_subject": "Sujet de courrier électronique",
  "message": "Message",
  "compose_your_email_message": "Composez votre message e-mail...",
  "send_email": "Envoyer par courriel",
  "bidder_portal": "Portail des soumissionnaires",
  "external_bidder_access_is_now_available": "L'accès externe aux soumissionnaires est maintenant disponible.",
  "bidder_portal_enabled": "Portail de soumissionnaire autorisé",
  "external_bidder_access_is_enabled_from_rfq_detail_via_invite_link": "L'accès aux soumissionnaires externes est activé du détail RFQ via des liens d'invitation.",
  "jan": "Jan",
  "feb": "Fébril",
  "mar": "Mar",
  "apr": "Avr",
  "may": "Mai",
  "jun": "Juno.",
  "jul": "Jul",
  "aug": "Aug",
  "sep": "Sep",
  "oct": "Oct oct.",
  "nov": "Nov",
  "dec": "Déc.",
  "operating": "Fonctionnement",
  "capex": "CapEx",
  "select_gl_account": "Sélectionnez le compte GL",
  "failed_to_load_procurement_data": "N ' a pas été chargé des données sur les achats",
  "failed_to_create_rfq": "N'a pas créé rfq",
  "create_professional_rfqs_with_ai_assistance": "Créer des RFQ professionnels avec l'aide d'IA",
  "start_new_rfq": "Commencer le nouveau RFQ",
  "phase_1": "Phase 1",
  "missing_required_fields": "Manque des champs obligatoires",
  "contact_name_email_total_amount_and_currency_are_required_to_subm": "Nom de contact, email, montant total, et devise sont nécessaires pour soumettre.",
  "submission_locked": "Soumission verrouillée",
  "this_offer_has_already_been_submitted_and_can_no_longer_be_edited": "Cette offre a déjà été soumise et ne peut plus être modifiée.",
  "deadline_passed": "Date limite fixée",
  "the_submission_deadline_has_passed_please_contact_the_club": "Le délai de soumission est passé. Veuillez contacter le club.",
  "file_uploaded": "Fichier téléchargé",
  "file_upload_failed": "Téléchargement de fichiers échoué",
  "loading_invitation": "Chargement de l'invitation...",
  "bidder_submission_portal": "Portail de soumission des soumissions",
  "request_for_quote": "Demande de devis",
  "category_520": "Catégorie:",
  "type_521": "Type:",
  "company": "Compagnie:",
  "your_offer_is_locked_editing_is_unavailable": "Votre offre est verrouillée. L'édition n'est pas disponible.",
  "contact_name": "Nom de contact",
  "contact_email": "E-mail de contact",
  "total_price": "Prix total",
  "currency_is_not_configured_please_contact_the_club_before_submitt": "La monnaie n'est pas configurée. Veuillez contacter le club avant de le soumettre.",
  "lead_time_days": "Temps de plomb (jours)",
  "validity_until": "Validité jusqu'à",
  "accepted_pdf_images_word_documents_or_text_files_max_10mb": "Acceptée : PDF , images, documents Word ou fichiers texte (max 10MB).",
  "save_draft": "Échec",
  "submit_offer": "Soumettre l'offre",
  "retry": "Veuillez réessayer.",
  "serverError": "Erreur de serveur",
  "budgetUnknown": "État budgétaire inconnu (refresh).",
  "awardedOverride": "Récipiendaire (dépassement)",
  "rfqAwarded": "RFQ attribué",
  "budgetLoading": "Chargement des budgets...",
  "budgetSelect": "Sélectionnez un budget",
  "budgetLinesLoading": "Chargement des lignes budgétaires...",
  "budgetLineSelect": "Sélectionnez une ligne budgétaire",
  "budgetLineSearch": "Chercher des lignes budgétaires...",
  "budgetLineError": "Incapable de charger des lignes budgétaires.",
  "budgetLinesEmpty": "Aucune ligne budgétaire n'a été trouvée.",
  "retryMoment": "Veuillez réessayer dans un instant.",
  "no": "Non",
  "submittedSuccessfully": "Soumis avec succès",
  "draftSaved": "Brouillon enregistré",
  "offerSubmitted": "Votre offre a été soumise au club.",
  "draftReturn": "Vous pouvez revenir à la mise à jour de ce projet à tout moment avant la date limite.",
  "submissionFailed": "Soumission échouée",
  "draftFailed": "Projet d ' échec",
  "expired": "Ce lien d'invitation a expiré. Veuillez demander un nouveau lien du club.",
  "invalid": "Ce lien d'invitation est invalide ou indisponible.",
  "reconciling": "La livraison de Microsoft est en cours de réconciliation. Privana ne résendra pas jusqu'à ce que le résultat du fournisseur soit connu.",
  "sendFailed": "Envoyé échoué",
  "supplierLinked": "Fournisseur déjà lié",
  "supplierCreated": "Fournisseur créé",
  "copied": "Le lien a été copié sur le presse-papiers.",
  "newCopied": "Nouveau lien copié sur le presse-papiers.",
  "selectGl": "Sélectionnez le compte GL",
  "searchGl": "Rechercher des comptes GL...",
  "emptyGl": "Aucun compte GL n'a trouvé.",
  "selectDepartment": "Sélectionnez le département",
  "searchDepartment": "Les départements de recherche...",
  "emptyDepartment": "Aucun ministère n'a été trouvé.",
  "primaryContact": "Contacts primaires",
  "selectRecipient": "Veuillez sélectionner au moins un appel d'offres à envoyer.",
  "emailFailed": "Failed to send email. Veuillez réessayer.",
  "enter": "Entrez.",
  "showing": "Affichage de {start} – {end} de {total} soumissionnaires",
  "daysValue": "Jours : {count}",
  "due": "Sommes dues: {date}",
  "publishedActivity": "RFQ publié: {title}",
  "submissionActivity": "Soumission à partir de {name}",
  "regenerateConfirm": "Régénérer le lien portail pour {name} ? Le lien précédent cessera de fonctionner.",
  "expires": "Expire {date}",
  "newExpires": "Nouveau lien expire {date}",
  "inviteEmailed": "Inviter courriel à {recipient}",
  "toRecipient": " à {recipient}",
  "emailSent": "E-mail envoyé. Nombre de destinataires : {count} !",
  "negotiationSubject": "Négociation du contrat - {name}",
  "reviewSubject": "Réunion d'examen des contrats - {name}",
  "portalUnavailable": "L'accès à l'échelle n'est pas disponible.",
  "enums": {
    "status": {
      "draft": "Brouillon",
      "published": "Publiée",
      "collecting_quotes": "Recueillir des cotes",
      "evaluation": "Évaluation",
      "awarded": "Récompensé",
      "closed": "Fermé",
      "cancelled": "Annulé",
      "active": "Actif",
      "inactive": "Inactif",
      "submitted": "Soumis",
      "invited": "Invités",
      "viewed": "Consulté",
      "pending": "En attente",
      "sent": "Envoyé",
      "failed": "Échec",
      "sending": "Envoi",
      "reconciling": "Réconciliation",
      "reconciliation_pending": "Réconciliation en attente",
      "board_approved": "Conseil approuvé",
      "approved": "Postes approuvés",
      "open": "Ouvert",
      "rejected": "Rejetée",
      "expired": "Expiré",
      "revoked": "Révoquée",
      "reconciliation pending": "Réconciliation en attente"
    },
    "risk": {
      "critical": "Critique",
      "high": "Élevé",
      "medium": "Moyen",
      "low": "Faible",
      "unknown": "Inconnu"
    },
    "recommendation": {
      "renew": "Renouvellement",
      "renegotiate": "Renégocier",
      "replace": "Remplacer",
      "review": "Examen"
    },
    "category": {
      "products": "Produits",
      "services": "Services",
      "maintenance": "Maintenance",
      "technology": "Technologie",
      "food_beverage": "Aliments et boissons",
      "linen_laundry": "Linge de maison & blanc",
      "landscaping": "Aménagement paysager",
      "security": "Sécurité",
      "other": "Autre",
      "Operating": "Fonctionnement",
      "CapEx": "CapEx"
    },
    "criterion": {
      "cost": "Coût",
      "quality": "Qualité",
      "service": "Service"
    },
    "activity": {
      "RFQIssued": "Demande de devis émise",
      "RFQUpdated": "Rfq mise à jour",
      "RFQSubmissionReceived": "Communication reçue",
      "RFQSubmissionEvaluated": "Submission assessed",
      "RFQAwarded": "RFQ attribué",
      "portal_link_generated": "Lien portail généré",
      "portal_link_regenerated": "Lien vers le portail régénéré",
      "created": "RFQ créé",
      "updated": "Rfq mise à jour",
      "status_changed": "Statut modifié",
      "bidder_invited": "Soumissionnaire invité",
      "bidder_invite_email_sent": "Adresse électronique de l ' invitation adressée au soumissionnaire",
      "bidder_invitation_email_sent": "Adresse électronique de l ' invitation adressée au soumissionnaire",
      "bidder_invitation_email_failed": "e-mail d'invitation à soumissionnaire échoué",
      "bidder_promoted_to_supplier": "Soumissionnaire promu fournisseur",
      "bidder_submission_file_uploaded": "Pièce jointe téléchargée",
      "budget_link_removed": "Lien budgétaire supprimé",
      "rfq_awarded": "RFQ attribué",
      "rfq_awarded_without_board_approval": "RFQ attribué sans approbation par le conseil d'administration",
      "sent_to_budget": "Envoyé au budget",
      "submission_created": "Offre créée",
      "submission_evaluated": "Offre évaluée",
      "submission_file_uploaded": "Offre jointe téléchargée"
    },
    "market": {
      "Beef": "Bœuf",
      "Pork": "Porc",
      "Poultry": "Volaille",
      "Dairy": "Laiterie",
      "Fruits": "Fruits",
      "Vegetables": "Légumes",
      "Ribeye": "Ribeye",
      "Striploin": "Strip-tease",
      "Tenderloin": "Filet",
      "Bacon": "Bacon",
      "Loins": "Les reins",
      "Hams": "Jambons",
      "Boneless Breast": "La poitrine désossée",
      "Wings": "Ailes",
      "Whole Broilers": "Broyeurs entiers",
      "Butter": "Beurre",
      "Cheddar": "Cheddar",
      "Milk": "Lait",
      "Apples": "Pommes",
      "Grapes": "Cépages",
      "Strawberries": "Fraises",
      "Lettuce": "Laitue",
      "Tomatoes": "Tomates",
      "Onions": "oignons",
      "Food": "Alimentation",
      "Fuel": "Carburant",
      "Energy": "Énergie",
      "Linens": "Linges",
      "Maintenance": "Maintenance",
      "Services": "Services",
      "Wine": "Vin",
      "Spirits": "Esprits",
      "Premium Wine": "Vin Premium",
      "Investment Wine": "Investissement dans le vin",
      "Food Ingredients": "Ingrédients alimentaires",
      "Packaging": "Emballage",
      "Meat": "Viande"
    },
    "schedule": {
      "Hourly": "Heureux",
      "Daily": "Quotidien",
      "Monthly": "mensuel",
      "Real-time": "En temps réel",
      "Intraday": "Intrajournalier"
    },
    "region": {
      "US Markets": "Marchés américains",
      "National & Regional": "National \" Regional",
      "US Economic Data": "Nous données économiques",
      "Global": "Mondial",
      "Global Fine Wine": "Vin raffiné mondial",
      "Global Food Supply": "A) Approvisionnement alimentaire mondial",
      "Regional Fuel Markets": "Marchés régionaux du carburant"
    },
    "trend": {
      "rising": "En hausse",
      "falling": "Tombant",
      "stable": "Écurie"
    },
    "unit": {
      "lb": "lb",
      "cwt": "cwt",
      "bag": "sac",
      "carton": "carton"
    }
  },
  "outbound": {
    "greeting": "Bonjour.",
    "greetingName": "Bonjour {name},",
    "submit": "Soumettez votre devis",
    "questions": "Si vous avez des questions, répondez à ce courriel.",
    "deadline": "Date limite de soumission: {date}",
    "inviteSubject": "Vous êtes invité à soumettre une soumission: {title}",
    "inviteBody": "Vous êtes invité à soumettre un devis pour {number} : {title} .",
    "submitHere": "Soumettez votre devis ici: {url}",
    "receivedSubject": "Proposition reçue — {label}",
    "receivedBody": "Nous avons reçu votre proposition pour {label} .",
    "thanks": "Merci de soumettre votre réponse. Notre équipe l'examinera et le suivra si nous avons besoin de quelque chose d'autre.",
    "draftSubject": "Demande de devis : {number} — {title}",
    "draftBody": "Nous aimerions inviter {name} à soumettre un devis pour {number} : {title} .",
    "responseNotification": "{name} a répondu à votre QR: {title}"
  },
  "errors": {
    "ai_invalid_json": "Le RFQ généré n'a pas pu être lu. Veuillez réessayer.",
    "ai_invalid_response": "Le RFQ généré est incomplet. Veuillez réessayer.",
    "award_submission_not_budgeted": "L'offre sélectionnée ne correspond pas à l'offre budgétaire.",
    "bidder_not_found": "Monnaie non trouvée.",
    "budget_line_not_found": "La ligne budgétaire n'a pas été trouvée.",
    "budget_missing_current_version": "Ce budget n'a pas de version actuelle.",
    "budget_not_board_approved": "Le budget exige l'approbation du conseil.",
    "budget_not_found": "Le budget n'a pas été trouvé.",
    "budget_submission_missing": "Sélectionnez une offre à envoyer au budget.",
    "club_currency_fetch_failed": "La monnaie du club n'a pas pu être chargée.",
    "club_identity_unavailable": "L'information du club n'est pas disponible.",
    "currency_mismatch": "La devise de l'offre doit correspondre à la devise du club.",
    "description_required": "Une description est requise.",
    "draft_not_found": "Le projet d'invitation n'a pas été trouvé.",
    "duplicate_or_invalid_bidder": "Un soumissionnaire sélectionné est invalide ou doublé.",
    "file_not_found": "Le fichier n'est pas trouvé.",
    "file_too_large": "Le fichier dépasse la limite de taille de téléchargement.",
    "file_upload_failed": "Le fichier n'a pas pu être téléchargé.",
    "invalid_bidders": "Sélectionnez les soumissionnaires valides.",
    "invalid_budget_line_id": "Sélectionnez une ligne budgétaire valide.",
    "invalid_club_code": "Le club ne pouvait pas être identifié.",
    "invalid_contact_email": "Entrez une adresse de contact valide.",
    "invalid_criteria": "Vérifiez les critères d'évaluation.",
    "invalid_file_type": "Ce type de fichier n'est pas pris en charge.",
    "invalid_limit": "La taille de la page demandée est invalide.",
    "invalid_multipart": "Le téléchargement ne peut pas être lu. Sélectionnez le fichier à nouveau.",
    "invalid_offset": "La page demandée est invalide.",
    "invalid_request": "Vérifiez le formulaire et réessayez.",
    "invalid_scores": "Vérifiez que les cotes d'évaluation sont dans la fourchette autorisée.",
    "invalid_status": "Sélectionnez un statut valide.",
    "invalid_status_transition": "Ce changement de statut n'est pas autorisé.",
    "invite_not_found": "Invitation non trouvée.",
    "mailbox_changed_regenerate_drafts": "Votre boîte aux lettres a changé.",
    "missing_bidder_email": "Ajouter une adresse e-mail pour ce soumissionnaire.",
    "missing_file": "Sélectionnez un fichier pour télécharger.",
    "missing_required_fields": "Remplissez les champs requis.",
    "name_required": "Un nom de soumissionnaire est requis.",
    "need_text_required": "Décrivez vos besoins d'approvisionnement.",
    "need_text_too_long": "Garder le besoin d'approvisionnement dans 4 000 caractères.",
    "no_updates": "Aucun changement n ' a été apporté.",
    "rate_limit_exceeded": "Trop de demandes. Veuillez réessayer plus tard.",
    "rate_limited": "Trop de demandes. Veuillez réessayer plus tard.",
    "recipient_must_match_bidder_contact": "Le destinataire doit correspondre au contact du soumissionnaire sélectionné.",
    "rfq_already_awarded": "Ce RFQ a déjà été attribué.",
    "rfq_already_sent_to_budget": "Ce RFQ a déjà été envoyé au budget.",
    "rfq_not_accepting_submissions": "Ce RFQ n'accepte pas les offres.",
    "rfq_not_awarded": "Attribue ce RFQ avant de promouvoir son soumissionnaire.",
    "rfq_not_eligible": "Ce RFQ n'est pas admissible à cette mesure.",
    "rfq_not_found": "RFQ non trouvé.",
    "rfq_not_sent_to_budget": "Envoyez ce RFQ au budget d'abord.",
    "scoring_template_not_found": "Modèle de notation n'a pas été trouvé.",
    "send_in_progress": "Ce courriel est déjà envoyé.",
    "send_reconciliation_pending": "La livraison est vérifiée. S'il vous plaît attendre avant la rentrée.",
    "send_reconciliation_required": "La livraison doit être vérifiée avant la rentrée.",
    "submission_failed": "L'offre ne peut pas être soumise. Veuillez réessayer.",
    "submission_not_found": "Offre non trouvée.",
    "submission_rfq_mismatch": "Cette offre appartient à un RFQ différent.",
    "weights_must_sum_to_100": "Les poids d'évaluation doivent totaliser 100%."
  },
  "newActions": {
    "review": "Réunion d ' examen de la performance",
    "research": "Recherche d'autres soumissionnaires",
    "negotiate": "Élaborer une stratégie de négociation",
    "terms": "Modalités et conditions du contrat de révision"
  },
  "contractDefault": "{rfq} Contrat octroyé",
  "dayValue": "Jours : {count}",
  "showingOne": "Affichage de {start} – {end} de {total} soumissionnaire",
  "emailSentOne": "E-mail envoyé. Nombre de destinataires : {count} !"
};
